import React from 'react';
import Select, { StylesConfig } from 'react-select';
import { ISelectOption } from '../ISelectOption';

interface TypeLogSelectProps {
    selectedTypeLog: string | null;
    setSelectedTypeLog: (type: string | null) => void;
}

type TypeLog = { key: string; value: string };

const customStyles: StylesConfig<ISelectOption, false> = {
    control: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
        maxWidth: '100%',
    }),
    singleValue: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menu: (provided) => ({
        ...provided,
        width: 'auto',
        minWidth: '150px',
    }),
    option: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
    }),
    menuPortal: (provided) => ({
        ...provided,
        zIndex: 9999,
    }),
};

const TypeLogSelect: React.FC<TypeLogSelectProps> = ({ selectedTypeLog, setSelectedTypeLog }) => {
    const typeLogs: TypeLog[] = [
        { key: 'Error', value: 'Error' },
        { key: 'Warning', value: 'Warning' },
        { key: 'Information', value: 'Information' },
        { key: 'Debug', value: 'Debug' },
        { key: 'Fatal', value: 'Fatal' },
    ];

    const options: ISelectOption[] = typeLogs.map((typeLog) => ({
        value: typeLog.key,
        label: typeLog.value,
    }));

    const handleChange = (selectedOption: ISelectOption | null) => {
        setSelectedTypeLog(selectedOption ? selectedOption.value : null);
    };

    return <Select id="autoSizingSelect" value={options.find((option) => option.value === selectedTypeLog)} options={options} onChange={handleChange} placeholder={'--- Type de log'} isClearable isSearchable styles={customStyles} classNamePrefix="react-select" menuPortalTarget={document.body} />;
};

export default TypeLogSelect;
